import React, { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{
          display: "flex", flexDirection: "column", alignItems: "center",
          justifyContent: "center", height: "100vh", fontFamily: "Poppins, sans-serif",
          textAlign: "center", padding: 20
        }}>
          <h1 style={{ fontSize: 28, color: "#cc0000" }}>Something went wrong</h1>
          <p style={{ color: "#666", marginBottom: 20 }}>Please refresh the page to try again.</p>
          <button
            onClick={() => window.location.reload()}
            style={{
              padding: "12px 30px", background: "#cc0000", color: "#fff",
              border: "none", borderRadius: 4, cursor: "pointer", fontSize: 16
            }}
          >
            Refresh Page
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
